<mat-dialog-content>
    <app-v-player [src]="src" [poster]="poster"></app-v-player>
</mat-dialog-content>

